registerComponent("pages/login", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * 85 linhas viraram estas: o jQuery Validate e o jquery.mask estão em
 * `Asa.formulario`, e aqui fica só o que é do login — a regra do CPF, a máscara
 * e as duas peculiaridades abaixo, que são de 2020 e ficam como estão.
 *
 * ⚠️ **ESTE FORMULÁRIO NÃO ENVIA NADA, DE PROPÓSITO.** O `submitHandler` de
 * 2020 está inteiramente comentado: a tela valida, mascara, destrava o botão e
 * o clique não faz nada. Reproduzido pelo `enviar: false` — sem ele o `fetch`
 * postaria na própria página, e `/en/login` só tem rota `GET`. Decidir o
 * destino desta tela é "Achado para o responsável" (item 4 do programa), não
 * transposição.
 *
 * ⚠️ **E a página só existe em EN** (`/en/login`; a rota pt está comentada em
 * `routes/site/web.php`), embora valide **CPF** — a alternativa por idioma do
 * legado (`cpfBR: (isPt) ? true : false`) está comentada logo acima da regra
 * ligada. Mantido à letra: quem chega em `/en/login` continua precisando de um
 * CPF válido.
 *
 * O que MUDA de comportamento: `keyup` → `input` nos campos (ver
 * `blocks/input`).
 */

const form = component.querySelector('.wrap-login');

Asa.formulario(form, {
    // O `submitHandler` vazio de 2020 — ver o aviso do cabeçalho.
    enviar: false,
    regras: {
        cpf: { cpf: true },
    },
    mascaras: {
        cpf: '000.000.000-00',
    },
    /*
     | O `errorPlacement: () => false` de 2020: o rótulo de erro é criado e
     | NUNCA inserido. Esta tela sinaliza o campo inválido só pela borda
     | (`.box-input.error`), sem texto — é o único dos seis formulários do site
     | que faz isso, e mudar seria inventar UI.
     */
    posicionarErro: () => true,
    /*
     | O `highlight`/`unhighlight` de 2020 marcava só o `.box-input`, e não a
     | raiz do `blocks/input` — que tem `&.error { padding-bottom: 15rem }` na
     | folha. Marcar as duas abriria 15rem de folga abaixo de um campo que não
     | mostra mensagem.
     */
    alvosDoEstado: (campo) => [campo.closest('.box-input')].filter(Boolean),
});

});
